import React from "react";
import IdealStudio from "../../../../core/editor/main";

const warned = new Set();

// Saved courses can reference a pluginId the running bundle doesn't register
// (old deploy, unknown id). Callers use this instead of `Plugins.get(id)` and
// bail out / render <UnknownPluginBox/> when it returns undefined.
export function getPluginSafe(id) {
  const plugin = IdealStudio.Plugins.get(id);
  if (!plugin && !warned.has(id)) {
    warned.add(id);
    console.warn("[Editor] Plugin not registered:", id);
  }
  return plugin;
}

export default function UnknownPluginBox({ id, box, toolbar }) {
  const s = toolbar.structure || {};
  const pos = box.position || {};
  return (
    <div
      id={"box-" + id}
      style={{
        position: pos.type,
        left: pos.x || "",
        top: pos.y || "",
        width: s.width && s.width !== "auto" ? s.width + (s.widthUnit || "") : 160,
        height: s.height && s.height !== "auto" ? s.height + (s.heightUnit || "") : 60,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: 4,
        boxSizing: "border-box",
        overflow: "hidden",
        background: "#f1f3f5",
        border: "1px dashed #adb5bd",
        color: "#6c757d",
        fontSize: 12,
      }}
    >
      {IdealStudio.i18n.t("unknownPlugin", { id: toolbar.pluginId })}
    </div>
  );
}
